import $ from "jquery";
import {
  ChangeGlobalMorph,
  GetGroup,
  GetMesh,
  hideIcon,
  pergola,
  pergolaConst,
  setAllHotspotsVisibility,
  showIcon,
  toggleBackWall,
  toggleLeftWall,
  toggleRightWall,
  triggerIconClick,
} from "../../../../../core/3d-configurator";
import {
  removeFromUrlSystemBySide,
  removeFromUrlSystemByType,
} from "../../../../../core/customFunctions/initiSubSystem";
import { state } from "../../../../../core/settings";
import {
  groups,
  stringPostSize,
  stringRoofType,
  stringTypePegola,
} from "../../../interface";
import "./interfaceGroupInputs.scss";
import { generateRangeHTML } from "./range/generateRange";
import * as THREE from "three";

export const colors = {
  White: "#1C1C1C",
  Grey: "#F5F5F5",
  Black: "#B0B0B0",
  Coffee: "#36454F",
  Oak: "#3F1A00",
};

export const typesInputs = {
  modelType: "manufacturer",
  selectButton: "select",
  range: "button",
  postSize: "post-size",
  colorsButton: "colorsButton",
  electronic: "electro",
  subSystem: "system",
  roofForLite: "liteRoof",
  typePergola: "typePergola",
  roofType: "roofTypes",
};

export let stringNameRoofColor = null;
export let stringNameFrameColor = null;

export const typeSubSystem = {
  "Motorized Zip Screen": "Motorized Zip Screen",
  "Sliding Glass Door": "Sliding Glass Door",
  "Bi-folding Glass Door": "Bi-folding Glass Door",
  "Fixed Shutters": "Fixed Shutters",
  "Sliding Shutters": "Sliding Shutters",
  "Bi-Ffolding Shutters": "Bi-Ffolding Shutters",
  "Fixed Slats": "Fixed Slats",
};

export function updateTextParam(
  customSetting,
  context,
  electro = false,
  onlyText = false,
  subSystem = false,
  walls = false
) {
  const text = [];

  if (!electro) {
    if (customSetting.backWall) {
      text.push("Back Wall");
    }
    if (customSetting.leftWall) {
      text.push("Left Wall");
    }
    if (customSetting.rightWall) {
      text.push("Right Wall");
    }
    if (
      !customSetting.rightWall &&
      !customSetting.leftWall &&
      !customSetting.backWall &&
      state.wallOption !== 4
    ) {
      text.push("Freestanding");
    } else if (state.wallOption === 4) {
      text.push("Cantilever");
    }
  }
  if (subSystem) {
    customSetting.subSystem.forEach((option) => text.push(option));
  }
  if (electro) {
    customSetting.electro.forEach((option) => {
      text.push(option);
    });
  }

  let displayText = "";

  if (text.length > 1) {
    displayText = text.join(", ");
    if (displayText.length > 15) {
      displayText = displayText.substring(0, 12) + "...";
    }
  } else {
    displayText = text.length === 1 ? text[0] : "-";
  }
  if (onlyText) {
    return displayText;
  }

  $(context)
    .closest(".interface__group")
    .find(".interface__group__head__param")
    .text(displayText);
}

let textureWood = null;

const loader = new THREE.TextureLoader();
loader.load("public/img/textures/wood_golden_oak.jpg", (texture) => {
  texture.flipY = false;
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(2, 2); // або інші значення
  texture.offset.set(0.1, 0.2);
  texture.center.set(0.5, 0.5); // обертання навколо центру
  texture.rotation = Math.PI / 2;
  textureWood = texture;
});

export function updateMaterialMap(mesh, hex) {
  if (mesh?.material) {
    mesh.material.map = null;
    mesh.material.color.set(hex);
    mesh.material.needsUpdate = true;

    if (hex === "#A56025") {
      mesh.material.map = textureWood;
      mesh.material.needsUpdate = true;
      mesh.material.color.set(0x5c3a21);
    }
  }
}

export function interfaceGroupInputsComponent(
  type,
  ranges,
  initValue = false,
  title
) {
  switch (type) {
    case typesInputs.modelType:
      const radioModelInputs = $(`
                <form class="type_interface_radio-model">
                  <div class="type_interface_radio-model_item option">
                    <input data-value="0" class="type_interface_radio-model_option type_interface_radio-model_option--azenco" 
                        type="radio" id="Azenco" name="fav_language" value="Azenco">
                    <label class="type_interface_radio-model_label" for="Azenco">Azenco</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input data-value="1" class="type_interface_radio-model_option type_interface_radio-model_option--four-seasons" 
                        type="radio" id="four-seasons" name="fav_language" value="four-seasons">
                    <label class="type_interface_radio-model_label" for="four-seasons">Four Seasons</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input data-value="2" class="type_interface_radio-model_option type_interface_radio-model_option--4K" 
                        type="radio" id="4K" name="fav_language" value="4K">
                    <label class="type_interface_radio-model_label" for="4K">4K</label>
                  </div>
                </form>`);

      const activeModelClass = "type_interface_radio-model_item--active";

      //REDIRECT LOGIC
      const azenco = radioModelInputs.find(".option").eq(0);
      const fourSeason = radioModelInputs.find(".option").eq(1);
      // const fourK = radioModelInputs.find(".option").eq(2);

      azenco.on("click", function () {
        const link =
          "https://koolcovers.s3.us-east-1.amazonaws.com/configurator/azenco/dist/index.html";
        window.location.href = link;
      });
      fourSeason.on("click", function () {
        const link =
          "https://koolcovers.s3.us-east-1.amazonaws.com/configurator/four-season/dist/index.html";
        window.location.href = link;
      });
      // fourK.on("click", function () {
      //   const link =
      //     "https://s3.eu-central-1.amazonaws.com/marevo.vision/RelevantProjects/webAR/Marevo-OM/Kool+Covers+-+links/4k/dist/index.html";
      //   window.location.href = link;
      // });

      //INIT MODEL
      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");

          console.log("INIT MODEL", state.type3Dmodel);

          if (state.type3Dmodel === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeModelClass);
          }
        });

      //#region HANDLE MODEL
      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          // CHANGE STATE
          state.type3Dmodel = +$(this).attr("data-value");

          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );

          // updateRoofInputs(roofGroup);
          updateUIAfterModelChange(parentItem);

          // updatePostSize();
          pergola.update();
        });

      //#region ROOF PARAMS
      function createRoofGroup() {
        return {
          title: "Roof",
          param: !state.model ? "Louvered" : state.moodLight,
          type: !state.model ? typesInputs.range : typesInputs.roofForLite,
          ranges: [
            {
              title: "Rotation",
              min: 0,
              max: 90,
              step: 1,
              thumb: false,
              initialValue: state.currentRotationZ,
              showLabels: true,
              showSwitchAngle: true,
            },
          ],
        };
      }
      //#endregion

      //#region ADD ROOF GROUP
      function updateRoofInputs(roofGroup) {
        const inputsRoof = $($(".interface__group")[2]).find(
          ".interface__group__inputs"
        );
        const newInputs = interfaceGroupInputsComponent(
          roofGroup.type,
          roofGroup.ranges,
          roofGroup.initValuePostSize,
          roofGroup.title
        );

        inputsRoof
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(roofGroup.param);

        inputsRoof.empty();
        inputsRoof.append(newInputs);
      }
      //#endregion

      //#region UPDATE UI
      function updateUIAfterModelChange(parentItem) {
        groups[0].param = $(parentItem).find("label").text();
        $(parentItem)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(groups[0].param);

        radioModelInputs
          .find(".type_interface_radio-model_item")
          .removeClass(activeModelClass);

        parentItem.addClass(activeModelClass);
      }
      //#endregion

      //#region UPDATE POST
      function updatePostSize() {
        const postSizeOptions = $(".type_interface_post-size_item");
        const activeClass = "type_interface_post-size_item--active";
        const param = !state.model ? `8" x 8"` : `4" x 4"`;

        ChangeGlobalMorph("4-8", 0.5);

        postSizeOptions.eq(0).addClass(activeClass);
        postSizeOptions.eq(1).removeClass(activeClass);

        state.initValuePostSize = "6";
        postSizeOptions.eq(1).text(param);

        $(".interface__group")
          .find(".interface__group__head__param")
          .eq(5)
          .text('6" x 6"');

        if (!state.model) {
          $("#param-light").show();
        } else {
          $("#param-light").hide();
        }
      }
      //#endregion
      //#endregion

      return radioModelInputs;

    case typesInputs.roofType:
      const radioRoofTypeContent = $(`
                <form class="type_interface_radio-model">
                  <div class="type_interface_radio-model_item option">
                    <input data-value="0" class="type_interface_radio-model_option type_interface_radio-model_option--solid" 
                        type="radio" id="shade" name="fav_language" value="${stringRoofType[0]}"
                        style="height: 90px"
                        >
                    <label class="type_interface_radio-model_label" for="shade">${stringRoofType[0]}</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input data-value="1" class="type_interface_radio-model_option type_interface_radio-model_option--lattice" 
                        type="radio" id="blade" name="fav_language" value="${stringRoofType[1]}"
                        style="height: 90px"
                        >
                    <label class="type_interface_radio-model_label" for="blade">${stringRoofType[1]}</label>
                  </div>
                </form>`);

      const activeRoofTypeClass = "type_interface_radio-model_item--active";

      // //INIT MODEL
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");

          if (!state.roofType) {
            showIcon(10);
          } else {
            showIcon(11);
          }

          if (state.roofType === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeRoofTypeClass);
          }

          setTimeout(() => {
            if (!state.roofType) {
              $("#wood-toggle").hide();
              // state.colorRoof = "#000000";
              // updateMaterialMap(pergola.roof.solidRoof[0].object);
            } else {
              $("#wood-toggle").show();
            }
          }, 1000);
        });

      //#region HANDLE MODEL
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          // CHANGE STATE
          state.roofType = +$(this).attr("data-value");
          $("#steel").removeClass("disable");

          hideIcon(10);
          hideIcon(11);
          $("rain").removeClass("active");
          state.rain = false;

          if (!state.roofType) {
            showIcon(10);
            // state.colorRoof = "#000000";

            $("#wood-toggle").hide();

            if (state.wallOption === 4 && state.doubleBeam) {
              $("#steel").addClass("disable");
            }
          } else {
            $("#wood-toggle").show();
            showIcon(11);
          }

          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );

          radioRoofTypeContent
            .find(".type_interface_radio-model_item")
            .removeClass(activeRoofTypeClass);

          parentItem.addClass(activeRoofTypeClass);

          $(parentItem)
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text($(this).val());

          // updatePostSize();

          // pergola.setAddOptionWall();
          pergola.update();
        });
      //#endregion

      return radioRoofTypeContent;

    case typesInputs.selectButton:
      const selectWalls = $(`
                <form class="type_interface_checkbox-wall type_interface_checkbox-wall--four-season">
                  <div class="wrapp-wall-add-option">
                    <div class="type_interface_post-size_item option" id="0">
                        <input class="type_interface_post-size_option" type="radio"  name="fav_language" value="Freestanding">
                        <label for="0">Freestanding</label>
                    </div>
               
                    <div class="type_interface_post-size_item option" id="1">
                        <input class="type_interface_post-size_option" type="radio"  name="fav_language" value="Wall-mounted">
                        <label for="1">Wall-mounted</label>
                   </div>
  
                    <div class="type_interface_post-size_item option" id="2">
                        <input class="type_interface_post-size_option" type="radio"  name="fav_language" value="Fascia-mounted">
                        <label for="0">Fascia-mounted</label>
                    </div>
               
                    <div class="type_interface_post-size_item option" id="3">
                        <input class="type_interface_post-size_option" type="radio"  name="fav_language" value="Roof-mounted">
                        <label for="1">Roof-mounted</label>
                   </div>

                    <div class="type_interface_post-size_item option" id="4">
                        <input class="type_interface_post-size_option" type="radio"  name="fav_language" value="Cantilever">
                        <label for="1">Cantilever</label>
                   </div>
                  </div>
                
                  <div class="wrapp-wall" id="wall-option">
                     <div class="type_interface_checkbox-wall_item option" id="back"> 
                    <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--back"></div>
  
                    <div class="type_interface_checkbox-wall_bottom">
                      <input class="type_interface_checkbox-wall_option" type="checkbox">
                      <label for="back">Back Wall</label>
                    </div> 
                  </div>
             
                  <div class="type_interface_checkbox-wall_item option" id="left"> 
                    <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--left"></div>
  
                    <div class="type_interface_checkbox-wall_bottom">
                      <input class="type_interface_checkbox-wall_option" type="checkbox">
                      <label for="left">Left Wall</label>
                    </div> 
                  </div>
               
                  <div class="type_interface_checkbox-wall_item option" id="right"> 
                    <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--right"></div>
  
                    <div class="type_interface_checkbox-wall_bottom">
                      <input class="type_interface_checkbox-wall_option" type="checkbox">
                      <label for="right">Right Wall</label>
                    </div> 
                  </div>
                </div>
                </form>
                 `);

      const activeWallClass = "active";
      const backWall = selectWalls.find("#back");
      const leftWall = selectWalls.find("#left");
      const rightWall = selectWalls.find("#right");

      function toggleClass(item, settings) {
        if (settings) {
          item.addClass(activeWallClass);
        } else {
          item.removeClass(activeWallClass);
        }
      }

      //INIT ADD OTPION
      selectWalls.find(".wrapp-wall-add-option .option").each(function () {
        const id = +$(this).attr("id");
        const $item = $(this);

        if (state.wallOption === id) {
          $item.addClass("active");
        }
      });

      setTimeout(() => {
        pergola.setAddOptionWall();
      }, 100);

      // INIT BUTTONS WALL
      toggleBackWall(state.backWall);
      toggleLeftWall(state.leftWall);
      toggleRightWall(state.rightWall);

      updateTextParam(state, backWall);

      if (state.backWall) {
        toggleClass(backWall, state.backWall);
      }
      if (state.leftWall) {
        toggleClass(leftWall, state.leftWall);
      }
      if (state.rightWall) {
        toggleClass(rightWall, state.rightWall);
      }

      // HANDLE BUTTONS WALL
      backWall.on("click", function () {
        state.backWall = !state.backWall;
        removeFromUrlSystemBySide(pergolaConst.side.Back);

        // const backBeam = GetMesh("back_beam_wall");
        // const backBeamL = GetMesh("beam_wall_L");
        // const backBeamR = GetMesh("beam_wall_L001");
        // backBeam.visible = false;
        // backBeamL.visible = false;
        // backBeamR.visible = false;

        // if (state.wallOption === 2) {
        //   if (state.backWall) backBeam.visible = true;
        //   if (state.leftWall) backBeamL.visible = true;
        //   if (state.rightWall) backBeamR.visible = true;
        // }

        pergola.checkWallOption();

        pergola.update();

        toggleBackWall(state.backWall);
        toggleClass($(this), state.backWall);

        // pergola.checkSystemsInScene();
        pergola.checkSystemsInScene();

        updateTextParam(state, this);
        // setAllHotspotsVisibility(false);
      });

      leftWall.on("click", function () {
        state.leftWall = !state.leftWall;
        removeFromUrlSystemBySide(pergolaConst.side.Left);

        // const backBeam = GetMesh("back_beam_wall");
        // const backBeamL = GetMesh("beam_wall_L");
        // const backBeamR = GetMesh("beam_wall_L001");
        // backBeam.visible = false;
        // backBeamL.visible = false;
        // backBeamR.visible = false;

        // if (state.wallOption === 2) {
        //   if (state.backWall) backBeam.visible = true;
        //   if (state.leftWall) backBeamL.visible = true;
        //   if (state.rightWall) backBeamR.visible = true;
        // }
        pergola.checkWallOption();

        pergola.update();

        toggleLeftWall(state.leftWall);
        toggleClass($(this), state.leftWall);

        // pergola.checkSystemsInScene();

        pergola.checkSystemsInScene();

        updateTextParam(state, this);
        // setAllHotspotsVisibility(false);
      });

      rightWall.on("click", function () {
        state.rightWall = !state.rightWall;
        removeFromUrlSystemBySide(pergolaConst.side.Right);

        // const backBeam = GetMesh("back_beam_wall");
        // const backBeamL = GetMesh("beam_wall_L");
        // const backBeamR = GetMesh("beam_wall_L001");
        // backBeam.visible = false;
        // backBeamL.visible = false;
        // backBeamR.visible = false;

        // if (state.wallOption === 2) {
        //   if (state.backWall) backBeam.visible = true;
        //   if (state.leftWall) backBeamL.visible = true;
        //   if (state.rightWall) backBeamR.visible = true;
        // }

        pergola.update();

        toggleRightWall(state.rightWall);
        toggleClass($(this), state.rightWall);

        // pergola.checkSystemsInScene();

        pergola.checkSystemsInScene();

        updateTextParam(state, this);
        // setAllHotspotsVisibility(false);
      });

      selectWalls
        .find(".wrapp-wall-add-option .option")
        .on("click", function () {
          const id = +$(this).attr("id");
          const $item = $(this);

          state.wallOption = id;

          selectWalls
            .find(".wrapp-wall-add-option .option")
            .removeClass("active");

          $item.addClass("active");

          pergola.setAddOptionWall();
          pergola.update();

          updateTextParam(state, this);
        });

      return selectWalls;

    case typesInputs.range:
      let rangesResult = $(``);

      if (ranges.length) {
        ranges.forEach((range) => {
          rangesResult = rangesResult.add(generateRangeHTML(range));
        });
      }

      return rangesResult;

    case typesInputs.postSize:
      const postSizeContent = $(`
              <form class="type_interface_post-size" id="post-size">
                  <div class="type_interface_post-size_item option disable-right" data-text="This post isn't available for Cantilever">
                      <input class="type_interface_post-size_option" type="radio" id="0" name="fav_language" value="${stringPostSize[0]}">
                      <label for="0">4" x 4"</label>
                  </div>
             
                  <div class="type_interface_post-size_item option" data-text="This post isn't available for Cantilever">
                      <input class="type_interface_post-size_option" type="radio" id="1" name="fav_language" value="${stringPostSize[1]}">
                      <label for="1">6" x 6"</label>
                 </div>

                  <div class="type_interface_post-size_item option">
                      <input class="type_interface_post-size_option" type="radio" id="2" name="fav_language" value="${stringPostSize[2]}">
                      <label for="1">8" x 8"</label>
                 </div>
              </form>
          `);

      const activeClass = "type_interface_post-size_item--active";

      //INIT INPUT
      postSizeContent.find(".type_interface_post-size_item").each(function () {
        $(this).removeClass(activeClass);

        if (state.postSize === +$(this).find("input").attr("id")) {
          $(this).addClass(activeClass);

          const paramLabel = $(this).find("input").val();

          const $groupHeadParam = $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param");

          $groupHeadParam.text(paramLabel);
        }
      });

      //HANDLE INPUT
      postSizeContent
        .find(".type_interface_post-size_item")
        .on("click", function () {
          if ($(this).hasClass("disable")) {
            return;
          }

          postSizeContent
            .find(".type_interface_post-size_item")
            .removeClass(activeClass);

          const paramLabel = $(this).find("input").val();
          state.postSize = +$(this).find("input").attr("id");

          $(this).addClass(activeClass);

          const $groupHeadParam = $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param");

          $groupHeadParam.text(paramLabel);

          pergola.update();
        });

      return postSizeContent;

    case typesInputs.typePergola:
      const typePergolaContent = $(`
            <form class="type_interface_post-size" style="flex-direction: row;">
                <div class="type_interface_post-size_item option">
                    <input class="type_interface_post-size_option" type="radio" id="0" name="fav_language" value="${stringTypePegola[0]}">
                    <label for="0">${stringTypePegola[0]}</label>
                </div>
           
                <div class="type_interface_post-size_item option">
                    <input class="type_interface_post-size_option" type="radio" id="1" name="fav_language" value="${stringTypePegola[1]}">
                    <label for="1">${stringTypePegola[1]}</label>
               </div>
            </form>
        `);

      const activeClassTypePergola = "active";

      //INIT INPUT
      typePergolaContent
        .find(".type_interface_post-size_item")
        .each(function () {
          $(this).removeClass(activeClassTypePergola);

          pergola.changeWallMaterials();

          if (state.typePergola === +$(this).find("input").attr("id")) {
            $(this).addClass(activeClassTypePergola);
          }
        });

      //HANDLE INPUT
      typePergolaContent
        .find(".type_interface_post-size_item")
        .on("click", function () {
          typePergolaContent
            .find(".type_interface_post-size_item")
            .removeClass(activeClassTypePergola);

          const paramLabel = $(this).find("input").val();
          state.typePergola = +$(this).find("input").attr("id");

          pergola.changeWallMaterials();

          $(this).addClass(activeClassTypePergola);

          const $groupHeadParam = $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param");

          $groupHeadParam.text(paramLabel);
          pergola.update();

          // toggleBackWall(state.backWall);
          // toggleLeftWall(state.leftWall);
          // toggleRightWall(state.rightWall);

          // updatePostSizeParams.call(this, selectedIndex);
        });

      return typePergolaContent;

    case typesInputs.colorsButton:
      const colorsRoof = [
        {
          name: "Matte White",
          value: "Matte White",
          image: "matte-white.png",
          id: "MatteWhite",
          hex: "#CAC6C5",
        },
        {
          name: "White",
          value: "White",
          image: "white.png",
          id: "White",
          hex: "#D7D1D0",
        },
        {
          name: "Adobe",
          value: "Adobe",
          image: "adobe.png",
          id: "Adobe",
          hex: "#b49f84",
        },
        {
          name: "Wheat",
          value: "Wheat",
          image: "wheat.png",
          id: "Wheat",
          hex: "#C7C2A9",
        },
        {
          name: "Ivory",
          value: "Ivory",
          image: "ivory.png",
          id: "Ivory",
          hex: "#E6D3B5",
        },
        {
          name: "Bronze",
          value: "Bronze",
          image: "bronze.png",
          id: "Bronze",
          hex: "#58544F",
        },
        {
          name: "Wood Grain",
          value: "Wood Grain",
          image: "public/img/textures/wood_golden_oak.jpg",
          id: "Wood Grain",
          hex: "#A56025",
        },
      ];

      const colorsFrame = [
        {
          name: "Espresso",
          value: "Espresso",
          image: "white.png",
          id: "Espresso",
          hex: "#514549",
        },
        {
          name: "Black",
          value: "Black",
          image: "adobe.png",
          id: "Black",
          hex: "#3A3A3C",
        },
        {
          name: "Apollo Grey",
          value: "Apollo Grey",
          image: "wheat.png",
          id: "Apollo Grey",
          hex: "#C9C9C9",
        },
        {
          name: "Quartz White",
          value: "Quartz White",
          image: "ivory.png",
          id: "Quartz White",
          hex: "#EFF0EA",
        },
        {
          name: "Adobe Tan",
          value: "Adobe Tan",
          image: "bronze.png",
          id: "Adobe Tan",
          hex: "#927959",
        },
      ];

      const colorItemsRoof = colorsRoof
        .map(
          (color) => `
          <div class="type_interface_colors-buttons_item option" data-hex="${
            color.hex
          }">
            <label class="type_interface_colors-buttons_label">
              <div class="image-container" style="background-color: ${
                color.hex
              };  ${
            color.name === "Wood Grain"
              ? `background-image: url('${color.image}')`
              : ""
          }"></div>
              <span class="color-name">${color.name}</span>
              <input class="type_interface_colors-buttons_option" type="radio" id="${
                color.id
              }" name="fav_language" value="${color.value}">
            </label>
          </div>
        `
        )
        .join("");

      const colorItemsFrame = colorsFrame
        .map(
          (color) => `
          <div class="type_interface_colors-buttons_item option" data-hex="${color.hex}">
            <label class="type_interface_colors-buttons_label">
              <div class="image-container" style="background-color: ${color.hex};"></div>
              <span class="color-name">${color.name}</span>
              <input class="type_interface_colors-buttons_option" type="radio" id="${color.id}" name="fav_language" value="${color.value}">
            </label>
          </div>
        `
        )
        .join("");

      const frameColorContent = $(`
          <form class="type_interface_colors-buttons">
            <div class="colors_container">
              ${colorItemsFrame}
            </div>
          </form>
        `);

      const roofColorContent = $(`
          <form class="type_interface_colors-buttons">
            <div class="colors_container" >            
              ${colorItemsRoof}
            </div>
          </form>
        `);

      const activeColorClass = "active";

      //LOGIC FOR FRAME COLOR
      if (title === "Frame Color") {
        const header = GetMesh("top_frame");

        //#region INIT INPUT
        frameColorContent.find(".option").each(function () {
          const $this = $(this);
          const hex = $(this).attr("data-hex");

          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          const bgImage = $imgContainer.css("background-image");

          const nameOfColor = $this.find("input").val();

          const extractPublicPath = (url) => {
            const match = url.match(/\/public\/.+$/);
            return match ? match[0] : url; // Якщо не знайдено — вертає як є
          };

          const backgroundColor = (() => {
            const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
            if (bgImage && bgImage !== "none" && match && match[1]) {
              return "/" + match[1].trim().replace(/^\/+/, ""); // гарантуємо початок з одного /
            } else {
              return pergola.rgbToHex(bgColor); // "#ffffff"
            }
          })();

          const normalizedStateColor = extractPublicPath(state.colorBody);

          if (normalizedStateColor === backgroundColor) {
            $item.addClass(activeColorClass);
            $this.prop("checked", true);
            stringNameFrameColor = nameOfColor;

            setTimeout(() => {
              $this
                .closest(".interface__group")
                .find(".interface__group__head__param")
                .text(nameOfColor);

              updateMaterialMap(header, hex);
            }, 400);
          }

          pergola.update();
        });

        //#endregion

        //#region HANDLE FRAME INPUTS
        frameColorContent.find(".option").on("change", function () {
          const $this = $(this);
          const hex = $(this).attr("data-hex");

          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          const bgImage = $imgContainer.css("background-image");

          let backgroundColor;
          const match = bgImage.match(/url\(["']?(.*?)["']?\)/);

          if (bgImage !== "none" && match && match[1]) {
            backgroundColor = match[1];
          } else {
            backgroundColor = pergola.rgbToHex(bgColor);
          }

          state.colorBody = backgroundColor;

          const nameOfColor = $this.find("input").val();
          stringNameFrameColor = nameOfColor;

          frameColorContent.find(".option").removeClass(activeColorClass);

          $item.addClass(activeColorClass);

          $this
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(nameOfColor);

          updateMaterialMap(header, hex);

          pergola.update();
        });
        // #endregion
      }

      //LOGIC FOR ROOF COLOR
      if (title === "Roof Color") {
        const lattice = GetMesh("lattice-1x4-x");
        const rain = GetGroup("rain_shield").children[1];
        const solid = GetGroup("roof-solid_over").children[1];

        //#region INIT INPUT
        setTimeout(() => {
          roofColorContent.find(".option").each(function () {
            const $this = $(this);
            const hex = $(this).attr("data-hex");
  
            const $item = $this.closest(".type_interface_colors-buttons_item");
            const $imgContainer = $item.find(".image-container");
  
            const bgColor = $imgContainer.css("background-color");
            const bgImage = $imgContainer.css("background-image");
  
            const nameOfColor = $this.find("input").val();
  
            const extractPublicPath = (url) => {
              const match = url.match(/\/public\/.+$/);
              return match ? match[0] : url; // Якщо не знайдено — вертає як є
            };
  
            const backgroundColor = pergola.rgbToHex(bgColor);
  
            const normalizedStateColor = extractPublicPath(
              state.colorRoof.includes("/") ? "#A56025" : state.colorRoof
            );
  
            if (normalizedStateColor.toLowerCase() === backgroundColor.toLowerCase()) {
              $item.addClass(activeColorClass);
              $this.prop("checked", true);
              stringNameRoofColor = nameOfColor;
  

                state.colorRoof = hex;
  
                $this
                  .closest(".interface__group")
                  .find(".interface__group__head__param")
                  .text(nameOfColor);
  
                updateMaterialMap(rain, hex);
                updateMaterialMap(lattice, hex);
                updateMaterialMap(solid, hex);
            }
  
            pergola.update();
          });
        }, 500)
  

        //#endregion

        //#region HANDLE ROOF INPUTS
        roofColorContent.find(".option").on("change", function () {
          const $this = $(this);
          const hex = $(this).attr("data-hex");

          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          const bgImage = $imgContainer.css("background-image");

          let backgroundColor;
          const match = bgImage.match(/url\(["']?(.*?)["']?\)/);

          if (bgImage !== "none" && match && match[1]) {
            backgroundColor = match[1];
          } else {
            backgroundColor = pergola.rgbToHex(bgColor);
          }

          state.colorRoof = backgroundColor;

          const nameOfColor = $this.find("input").val();
          stringNameRoofColor = nameOfColor;

          roofColorContent.find(".option").removeClass(activeColorClass);

          $item.addClass(activeColorClass);

          $this
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(nameOfColor);

          updateMaterialMap(rain, hex);
          updateMaterialMap(lattice, hex);
          updateMaterialMap(solid, hex);

          pergola.update();
        });
        // #endregion
      }

      return title === "Roof Color" ? roofColorContent : frameColorContent;

    case typesInputs.electronic:
      const electronicContent = $(`
                <form class="type_interface_electronic">
                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/electro/led-light.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">LED Lights</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="LED Lights">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/electro/mood-light.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Mood Light</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Mood Light">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/electro/fans.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Fans</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Fans">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/electro/Rectangle-3.svg" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Heaters</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Heaters">
                    </label>
                  </div>
                </form>
            `);

      const activeStyle = "type_interface_electronic_item--active";
      const portalLight = $(".portal-light");
      const portalHeaters = $(".portal-heaters");
      const sunIcon = $("#light");
      const heatersIcon = $("#heaters");
      const paramLight = electronicContent.find("#param-light");

      const closeButtonLight = $(".portal-light__close");
      const closeButtonHeaters = $(".portal-heaters__close");
      const closeButtonScreenElectro = $(".portal-screen__close");

      // INIT INPUT
      electronicContent.find('input[type="radio"]').each(function () {
        const $currentInput = $(this);
        const inputValue = $currentInput.val();

        switch (true) {
          case state.electro.has("Mood Light") && inputValue === "Mood Light":
            $currentInput.prop("checked", true);
            $currentInput
              .closest(".type_interface_electronic_item")
              .addClass(activeStyle);

            state.moodLight = true;
            triggerIconClick(7);

            break;

          case state.electro.has("LED Lights") && inputValue === "LED Lights":
            $currentInput.prop("checked", true);
            $currentInput
              .closest(".type_interface_electronic_item")
              .addClass(activeStyle);

            state.ledLights = true;
            triggerIconClick(6);

            break;

          case state.electro.has("Fans") && inputValue === "Fans":
            $currentInput.prop("checked", true);
            $currentInput
              .closest(".type_interface_electronic_item")
              .addClass(activeStyle);

            state.fans = true;

            break;

          case state.electro.has("Heaters") && inputValue === "Heaters":
            $currentInput.prop("checked", true);
            $currentInput
              .closest(".type_interface_electronic_item")
              .addClass(activeStyle);

            state.sideBeam = true;

            break;
        }

        pergola.update();

        updateTextParam(state, this, true);
      });

      // HANDLE INPUTS
      electronicContent.find('input[type="radio"]').on("click", function () {
        const $currentInput = $(this);
        const inputValue = $currentInput.val();

        switch (inputValue) {
          case "Mood Light":
            state.moodLight = !state.moodLight;
            state.electro.add(inputValue);

            if (!state.moodLight) {
              $currentInput.prop("checked", false);
              $currentInput
                .closest(".type_interface_electronic_item")
                .removeClass(activeStyle);
              state.electro.delete(inputValue);
              hideIcon(7);
            } else {
              $currentInput.prop("checked", true);
              $currentInput
                .closest(".type_interface_electronic_item")
                .addClass(activeStyle);
              state.electro.add(inputValue);
              triggerIconClick(7);
            }

            break;

          case "LED Lights":
            state.ledLights = !state.ledLights;
            state.electro.add(inputValue);

            if (!state.ledLights) {
              $currentInput.prop("checked", false);
              $currentInput
                .closest(".type_interface_electronic_item")
                .removeClass(activeStyle);
              state.electro.delete(inputValue);
              hideIcon(6);
            } else {
              $currentInput.prop("checked", true);
              $currentInput
                .closest(".type_interface_electronic_item")
                .addClass(activeStyle);
              state.electro.add(inputValue);
              triggerIconClick(6);
            }

            break;

          case "Fans":
            state.fans = !state.fans;
            state.electro.add(inputValue);

            if (!state.fans) {
              $currentInput.prop("checked", false);
              $currentInput
                .closest(".type_interface_electronic_item")
                .removeClass(activeStyle);
              state.electro.delete(inputValue);
            } else {
              $currentInput.prop("checked", true);
              $currentInput
                .closest(".type_interface_electronic_item")
                .addClass(activeStyle);
              state.electro.add(inputValue);
            }

            break;

          case "Heaters":
            state.sideBeam = !state.sideBeam;
            state.electro.add(inputValue);

            if (!state.sideBeam) {
              $currentInput.prop("checked", false);
              $currentInput
                .closest(".type_interface_electronic_item")
                .removeClass(activeStyle);
              state.electro.delete(inputValue);
            } else {
              $currentInput.prop("checked", true);
              $currentInput
                .closest(".type_interface_electronic_item")
                .addClass(activeStyle);
              state.electro.add(inputValue);
            }
            break;
        }

        updateTextParam(state, this, true);
        pergola.update();
      });

      return electronicContent;

    case typesInputs.subSystem:
      const subSystemContent = $(`
            <form class="type_interface_electronic" id="last-group">
              <div class="type_interface_electronic_item option" id="${pergolaConst.option.LEDRampLight}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/light.png" alt="${pergolaConst.optionNameString.LEDRampLight}" class="color-image">
                  </div>
                  <span class="electronic-name">${pergolaConst.optionNameString.LEDRampLight}</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.optionNameString.LEDRampLight}">
                </label>
              </div>
        
              <div class="type_interface_electronic_item option" id="${pergolaConst.option.fans}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/fan.png" alt="${pergolaConst.optionNameString.fans}" class="color-image">
                  </div>
                  <span class="electronic-name">${pergolaConst.optionNameString.fans}</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.optionNameString.fans}">
                </label>
              </div>
  
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.privacyWall}" data-text="Turn off Cantilever">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/privacy-wall.png" alt="${pergolaConst.systemNameString.privacyWall}" class="color-image">
                  </div>
                  
                  <span class="electronic-name">${pergolaConst.systemNameString.privacyWall}</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.privacyWall}">
                </label>
              </div>
        
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.autoShade}" data-text="Turn off Cantilever">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/auto-screen.png" alt="${pergolaConst.systemNameString.autoShade}" class="color-image">
                  </div>
                  <span class="electronic-name">${pergolaConst.systemNameString.autoShade}</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.autoShade}">
                </label>
              </div>
            </form>
          `);

      const activeStyleSubSystem = "type_interface_electronic_item--active";
      const screenIcon = $("#screen");
      const shadesIcon = $("#shades");
      const portalScreen = $(".portal-screen");
      const portalShades = $(".portal-shades");
      const closeButtonScreen = $(".portal-screen__close");
      const closeButtonShades = $(".portal-shades__close");

      function handleInputChange($input, init = false) {
        const inputValue = $input.val();

        setAllHotspotsVisibility(true);
        pergola.update();

        switch (inputValue) {
          case pergolaConst.systemNameString.autoShade:
            state.currentActiveSystems = pergolaConst.systemType.autoShade;
            break;

          case pergolaConst.systemNameString.privacyWall:
            state.currentActiveSystems = pergolaConst.systemType.privacyWall;
            break;

          default:
            break;
        }

        const isElectroOption = [
          pergolaConst.optionNameString.LEDRampLight,
          pergolaConst.optionNameString.LEDRecessed,
          pergolaConst.optionNameString.LEDStrip,
          pergolaConst.optionNameString.fans,
        ].includes(inputValue);

        const activateInput = ($input) => {
          $input.prop("checked", true);
          $input
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleSubSystem);
        };

        const deactivateInput = ($input) => {
          $input.prop("checked", false);
          $input
            .closest(".type_interface_electronic_item")
            .removeClass(activeStyleSubSystem);
        };

        const handleElectroOption = () => {
          if (state.electro.has(inputValue) && !init) {
            state.electro.delete(inputValue);
            deactivateInput($input);
            console.log("delete OPTION");
          } else {
            state.electro.add(inputValue);
            activateInput($input);
            state.currentActiveSystems = null;
          }
        };

        const handleSubSystemOption = () => {
          if (state.subSystem.has(inputValue) && !init) {
            state.subSystem.delete(inputValue);
            deactivateInput($input);

            pergola.removeSystemFromSpanType(state.currentActiveSystems);
            removeFromUrlSystemByType(state.currentActiveSystems);
            hideIcon(state.currentActiveSystems);

            state.currentActiveSystems = null;
          } else {
            state.subSystem.add(inputValue);
            activateInput($input);

            showIcon(state.currentActiveSystems);
          }
        };

        if (isElectroOption) {
          handleElectroOption();
        } else {
          handleSubSystemOption();
        }

        pergola.update();

        $input
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${updateTextParam(state, $input[0], true, true, true)}`);
      }

      //#region INIT INPUT
      subSystemContent.find('input[type="radio"]').each(function () {
        const $input = $(this);
        const inputValue = $input.val();

        if (state.subSystem.has(inputValue) || state.electro.has(inputValue)) {
          handleInputChange($input, true);
        }
      });
      //#endregion

      //#region HANDLE INPUTS
      subSystemContent.find('input[type="radio"]').on("click", function () {
        if ($(this).closest(".option").hasClass("disable")) {
          return;
        }
        handleInputChange($(this));
      });
      //#endregion

      return subSystemContent;

    case typesInputs.roofForLite:
      const roofContent = $(`
                <form class="type_interface_electronic">
                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/sletted.png" alt="Screens" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Slatted</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Slatted">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/screen-roof.png" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Screens</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Screens">
                    </label>
                  </div>
                </form>
                `);

      const activeStyleRoof = "type_interface_electronic_item--active";

      // INIT INPUT
      roofContent.find('input[type="radio"]').each(function () {
        const inputValue = $(this).val();

        if (state.moodLight === inputValue) {
          $(this)
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleRoof);
          $(this).prop("checked", true);
        }
      });

      // HANDLE INPUTS
      roofContent.find('input[type="radio"]').on("click", function () {
        const inputValue = $(this).val();
        state.moodLight = inputValue;

        // CURRENT OPTION
        $(this).prop("checked", true);
        $(this)
          .closest(".type_interface_electronic_item")
          .addClass(activeStyleRoof);

        // ALL OPTION
        $(this)
          .closest(".type_interface_electronic")
          .find(".type_interface_electronic_item")
          .not($(this).closest(".type_interface_electronic_item"))
          .removeClass(activeStyleRoof);

        // UPDATE TEXT
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${state.moodLight}`);

        pergola.update();
      });

      //#region SCREEN BUTTON HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(1)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.show();
          pergola.update();
        });
      //#endregion

      //#region SLATTED HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(0)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.hide();
          pergola.update();
        });
      //#endregion

      return roofContent;

    default:
      return `< div > NON HTML</div > `;
  }
}
